interface Props {
  page: "impressum" | "datenschutz";
  onClose: () => void;
}

export default function Legal({ page, onClose }: Props) {
  return (
    <div className="min-h-[100dvh] overflow-auto bg-ink-950">
      <article className="safe-pad mx-auto max-w-3xl px-4 py-8 text-slate-300">
        <button
          type="button"
          className="text-sm text-slate-400 hover:text-white"
          onClick={onClose}
        >
          ← Zurück
        </button>

        {page === "impressum" ? <Impressum /> : <Datenschutz />}
      </article>
    </div>
  );
}

function Impressum() {
  return (
    <>
      <h1 className="mt-4 font-display text-4xl text-white">
        Impressum
      </h1>

      <h2 className="mt-6 text-xs font-bold uppercase tracking-[0.25em] text-amber-glow">
        Angaben gemäß den gesetzlichen Informationspflichten
      </h2>

      <p className="mt-4 text-lg text-white">
        <strong>André Geiger</strong>
        <br />
        Ried 41
        <br />
        6531 Ried im Oberinntal
        <br />
        Österreich
      </p>

      <p className="mt-4">
        E-Mail:{" "}
        <a
          href="mailto:geiger.andre1@gmail.com"
          className="text-amber-glow hover:underline"
        >
          geiger.andre1@gmail.com
        </a>
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        Zweck dieser Website
      </h2>

      <p className="mt-3">
        Der Dart-Counter ist eine privat entwickelte und betriebene
        Webanwendung zur digitalen Anzeige und Verwaltung von Dartspielen.
      </p>

      <p className="mt-3">
        Die Anwendung wird unentgeltlich und ohne kommerziellen Zweck
        betrieben.
      </p>

      <p className="mt-3">
        Über die Website können laufende Dartspiele, die von einer
        zugehörigen Desktop-Anwendung bereitgestellt werden, über einen
        Spielraum verfolgt werden.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        Technische Umsetzung
      </h2>

      <p className="mt-3">
        Entwicklung und technische Umsetzung:
        <br />
        André Geiger
      </p>

      <p className="mt-3">
        Das Projekt wurde als privates, nicht kommerzielles
        Softwareprojekt entwickelt und wird unentgeltlich betrieben.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        Urheberrecht
      </h2>

      <p className="mt-3">
        Die Inhalte, Gestaltung und Software dieser Website sind,
        soweit gesetzlich geschützt, urheberrechtlich geschützt.
      </p>

      <p className="mt-3">
        Eine Vervielfältigung, Bearbeitung, Verbreitung oder sonstige
        Nutzung der geschützten Inhalte und Software über den gesetzlich
        zulässigen Umfang hinaus bedarf der Zustimmung des jeweiligen
        Rechteinhabers.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        Haftung für Inhalte
      </h2>

      <p className="mt-3">
        Die Inhalte dieser Website werden nach bestem Wissen erstellt.
        Für die Richtigkeit, Vollständigkeit und Aktualität der
        bereitgestellten Informationen wird keine Gewähr übernommen,
        soweit gesetzlich zulässig.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        Externe Links
      </h2>

      <p className="mt-3">
        Sofern diese Website Links zu externen Websites enthält, liegt
        die Verantwortung für deren Inhalte beim jeweiligen Betreiber.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        Datenschutz
      </h2>

      <p className="mt-3">
        Informationen zur Verarbeitung personenbezogener Daten finden
        Sie in unserer Datenschutzerklärung.
      </p>

      <p className="mt-8 text-sm text-slate-500">
        Stand: August 2026
      </p>
    </>
  );
}

function Datenschutz() {
  return (
    <>
      <h1 className="mt-4 font-display text-4xl text-white">
        Datenschutzerklärung
      </h1>

      <p className="mt-6">
        Der Schutz personenbezogener Daten ist uns wichtig. Diese
        Datenschutzerklärung informiert darüber, welche personenbezogenen
        Daten im Rahmen des Dart-Counters verarbeitet werden, zu welchen
        Zwecken dies erfolgt und welche Rechte betroffene Personen haben.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        1. Verantwortlicher
      </h2>

      <p className="mt-3">
        Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO)
        für die Verarbeitung personenbezogener Daten im Rahmen dieser
        Website ist:
      </p>

      <p className="mt-4 text-white">
        <strong>André Geiger</strong>
        <br />
        Ried 41
        <br />
        6531 Ried im Oberinntal
        <br />
        Österreich
      </p>

      <p className="mt-4">
        E-Mail:{" "}
        <a
          href="mailto:geiger.andre1@gmail.com"
          className="text-amber-glow hover:underline"
        >
          geiger.andre1@gmail.com
        </a>
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        2. Zweck und Funktionsweise des Dart-Counters
      </h2>

      <p className="mt-3">
        Der Dart-Counter ist eine privat entwickelte und unentgeltlich
        betriebene Webanwendung zur Darstellung und Verwaltung von
        Dartspielen.
      </p>

      <p className="mt-3">
        Eine zugehörige Desktop-Anwendung kann einen Spielraum erstellen.
        Zuschauer können über die entsprechende Raumkennung auf diesen
        Spielraum zugreifen und den dort bereitgestellten Spielstand
        verfolgen.
      </p>

      <p className="mt-3">
        Es werden keine persönlichen Benutzerkonten für Zuschauer
        eingerichtet. Eine Registrierung eines Zuschauers ist nicht
        erforderlich.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        3. Spielerdaten
      </h2>

      <p className="mt-3">
        Zur Verwaltung und Durchführung von Dartspielen werden Spieler
        in einer Datenbank gespeichert.
      </p>

      <p className="mt-3">
        Dabei können insbesondere folgende Daten verarbeitet werden:
      </p>

      <ul className="mt-3 list-disc space-y-1 pl-5">
        <li>Spieler- bzw. Anzeigename</li>
        <li>technische Kennung des Spielers</li>
        <li>Spielstatistiken, soweit vom Dart-Counter erfasst</li>
        <li>Zuordnung zu durchgeführten Spielen</li>
      </ul>

      <p className="mt-4">
        Der Zweck der Speicherung besteht darin, Spieler für die
        Verwendung im Dart-Counter bereitzustellen und durchgeführte
        Spiele sowie deren Ergebnisse zu verwalten und darzustellen.
      </p>

      <p className="mt-3">
        Spieler- bzw. Anzeigenamen können personenbezogene Daten
        darstellen, wenn sie einer bestimmten natürlichen Person
        zugeordnet werden können.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        4. Speicherung abgeschlossener Spiele
      </h2>

      <p className="mt-3">
        Abgeschlossene Dartspiele werden in der Datenbank gespeichert.
        Dabei können insbesondere Spieler, Spielstände, Spielverläufe,
        Ergebnisse sowie weitere für die Dokumentation des Spiels
        erforderliche Informationen gespeichert werden.
      </p>

      <p className="mt-3">
        Die Speicherung dient der Dokumentation und späteren
        Nachvollziehbarkeit bereits durchgeführter Spiele sowie der
        Bereitstellung entsprechender Spielstatistiken und Ergebnisse.
      </p>

      <p className="mt-3">
        Die gespeicherten Spieldaten werden nicht zu Werbe- oder
        Analysezwecken verwendet.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        5. Rechtsgrundlage der Verarbeitung
      </h2>

      <p className="mt-3">
        Die Verarbeitung der für den Betrieb des Dart-Counters
        erforderlichen Daten erfolgt auf Grundlage von Art. 6 Abs. 1
        lit. f DSGVO.
      </p>

      <p className="mt-3">
        Das berechtigte Interesse besteht im Betrieb der privaten
        Anwendung, der Verwaltung von Dartspielern und Spielen sowie der
        Bereitstellung und Dokumentation der entsprechenden Spielstände
        und Ergebnisse.
      </p>

      <p className="mt-3">
        Die Verarbeitung beschränkt sich auf Daten, die für diese Zwecke
        erforderlich sind.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        6. Zugriff auf Spielräume
      </h2>

      <p className="mt-3">
        Der Zugriff auf einen Spielraum erfolgt über die dafür
        vorgesehene Raumkennung bzw. Zugangsinformation.
      </p>

      <p className="mt-3">
        Die Raumkennung dient der technischen Zuordnung des jeweiligen
        Spiels und stellt kein persönliches Benutzerkonto dar.
      </p>

      <p className="mt-3">
        Personen, die einem Spielraum beitreten, können die im jeweiligen
        Spielraum bereitgestellten Spieldaten, insbesondere Spieler- bzw.
        Anzeigenamen und den aktuellen Spielstand, sehen.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        7. Cookies
      </h2>

      <p className="mt-3">
        Diese Website verwendet keine Cookies.
      </p>

      <p className="mt-3">
        Es werden insbesondere keine Cookies zu Analyse-, Werbe- oder
        Trackingzwecken eingesetzt.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        8. Analyse, Tracking und Werbung
      </h2>

      <p className="mt-3">
        Der Dart-Counter verwendet keine Dienste zur Analyse des
        Nutzungsverhaltens und keine personalisierten Werbedienste.
      </p>

      <p className="mt-3">
        Es werden insbesondere keine Dienste wie Google Analytics oder
        vergleichbare Webanalyse- und Trackingdienste eingesetzt.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        9. Server-Logfiles
      </h2>

      <p className="mt-3">
        Beim Zugriff auf die Website können durch den Webserver und den
        Hostinganbieter technisch erforderliche Informationen verarbeitet
        und in Server-Logfiles protokolliert werden.
      </p>

      <p className="mt-3">
        Hierzu können insbesondere gehören:
      </p>

      <ul className="mt-3 list-disc space-y-1 pl-5">
        <li>IP-Adresse</li>
        <li>Datum und Uhrzeit des Zugriffs</li>
        <li>aufgerufene Seite bzw. Ressource</li>
        <li>Informationen zum verwendeten Browser</li>
        <li>Informationen zum verwendeten Betriebssystem</li>
        <li>weitere technisch erforderliche Verbindungsdaten</li>
      </ul>

      <p className="mt-4">
        Diese Daten werden zur technischen Bereitstellung, zur
        Gewährleistung der Sicherheit sowie zur Erkennung und Abwehr
        missbräuchlicher Zugriffe und technischer Angriffe verarbeitet.
      </p>

      <p className="mt-3">
        Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. f DSGVO. Das
        berechtigte Interesse liegt im sicheren und zuverlässigen Betrieb
        des Dart-Counters.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        10. Hosting durch Hostinger
      </h2>

      <p className="mt-3">
        Diese Website und die zugehörige technische Infrastruktur werden
        über den Hostinganbieter Hostinger betrieben.
      </p>

      <p className="mt-3">
        Im Rahmen des Hostings können technisch erforderliche
        personenbezogene Daten verarbeitet werden. Dazu können
        insbesondere technische Verbindungs-, Zugriffs- und
        Protokolldaten gehören.
      </p>

      <p className="mt-3">
        Weitere Informationen zur Verarbeitung personenbezogener Daten
        durch Hostinger finden Sie in der{" "}
        <a
          href="https://www.hostinger.com/at/legal/datenschutz-bestimmungen"
          target="_blank"
          rel="noopener noreferrer"
          className="text-amber-glow hover:underline"
        >
          Datenschutzerklärung von Hostinger
        </a>
        .
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        11. Kontaktaufnahme
      </h2>

      <p className="mt-3">
        Eine Kontaktaufnahme ist über die im Impressum angegebene
        E-Mail-Adresse möglich.
      </p>

      <p className="mt-3">
        Wenn Sie uns per E-Mail kontaktieren, werden die von Ihnen
        übermittelten personenbezogenen Daten zur Bearbeitung Ihrer
        Anfrage und für gegebenenfalls erforderliche Anschlussfragen
        verarbeitet.
      </p>

      <p className="mt-3">
        Die Daten werden gelöscht, sobald der Zweck der Verarbeitung
        entfällt und keine gesetzlichen Aufbewahrungspflichten oder
        sonstigen rechtlichen Gründe für eine weitere Speicherung
        bestehen.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        12. Speicherdauer
      </h2>

      <p className="mt-3">
        Die in der Datenbank gespeicherten Spieler- und Spieldaten werden
        grundsätzlich so lange gespeichert, wie sie für die Verwaltung
        und Dokumentation der Dartspiele erforderlich sind.
      </p>

      <p className="mt-3">
        Eine automatische Löschung abgeschlossener Spiele erfolgt derzeit
        nicht, sofern eine solche Löschung technisch nicht vorgesehen ist.
      </p>

      <p className="mt-3">
        Eine Löschung oder Änderung personenbezogener Daten kann im
        Rahmen der gesetzlichen Voraussetzungen beim Verantwortlichen
        beantragt werden.
      </p>

      <p className="mt-3">
        Technische Server- und Zugriffsdaten werden entsprechend den
        technischen und sicherheitsbezogenen Erfordernissen des
        Hostings verarbeitet und gespeichert.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        13. Empfänger personenbezogener Daten
      </h2>

      <p className="mt-3">
        Personenbezogene Daten werden grundsätzlich nicht zu
        Werbe-, Marketing- oder Analysezwecken an Dritte weitergegeben.
      </p>

      <p className="mt-3">
        Soweit dies für den technischen Betrieb der Website erforderlich
        ist, können personenbezogene Daten durch technische
        Dienstleister verarbeitet werden.
      </p>

      <p className="mt-3">
        Hierzu gehört insbesondere der eingesetzte Hostinganbieter
        Hostinger.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        14. Datensicherheit
      </h2>

      <p className="mt-3">
        Es werden angemessene technische und organisatorische Maßnahmen
        getroffen, um die gespeicherten personenbezogenen Daten vor
        unbefugtem Zugriff, Verlust, Veränderung oder sonstiger
        unrechtmäßiger Verarbeitung zu schützen.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        15. Ihre Rechte
      </h2>

      <p className="mt-3">
        Ihnen stehen nach Maßgabe der gesetzlichen Voraussetzungen
        insbesondere folgende Rechte zu:
      </p>

      <ul className="mt-3 list-disc space-y-1 pl-5">
        <li>Recht auf Auskunft</li>
        <li>Recht auf Berichtigung</li>
        <li>Recht auf Löschung</li>
        <li>Recht auf Einschränkung der Verarbeitung</li>
        <li>Recht auf Datenübertragbarkeit</li>
        <li>Recht auf Widerspruch gegen bestimmte Verarbeitungen</li>
      </ul>

      <p className="mt-4">
        Zur Ausübung Ihrer Rechte können Sie sich jederzeit an den oben
        genannten Verantwortlichen wenden.
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        16. Beschwerderecht
      </h2>

      <p className="mt-3">
        Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
        personenbezogenen Daten gegen datenschutzrechtliche Vorschriften
        verstößt, haben Sie das Recht, eine Beschwerde bei der zuständigen
        Datenschutzaufsichtsbehörde einzubringen.
      </p>

      <p className="mt-4 text-white">
        <strong>Österreichische Datenschutzbehörde</strong>
        <br />
        Barichgasse 40–42
        <br />
        1030 Wien
        <br />
        Österreich
      </p>

      <p className="mt-4">
        Telefon: +43 1 52 152-0
        <br />
        E-Mail:{" "}
        <a
          href="mailto:dsb@dsb.gv.at"
          className="text-amber-glow hover:underline"
        >
          dsb@dsb.gv.at
        </a>
      </p>

      <p className="mt-4">
        Weitere Informationen finden Sie auf der{" "}
        <a
          href="https://dsb.gv.at/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-amber-glow hover:underline"
        >
          Website der Österreichischen Datenschutzbehörde
        </a>
        .
      </p>

      <h2 className="mt-8 font-display text-2xl text-white">
        17. Aktualisierung dieser Datenschutzerklärung
      </h2>

      <p className="mt-3">
        Diese Datenschutzerklärung kann angepasst werden, wenn sich die
        technische Ausgestaltung des Dart-Counters oder die damit
        verbundenen Datenverarbeitungen ändern.
      </p>

      <p className="mt-8 text-sm text-slate-500">
        Stand: August 2026
      </p>
    </>
  );
}
